import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useProjectProfiles(projectId: number | null) {
  return useQuery({
    queryKey: ["projects", projectId, "profiles"],
    queryFn: () => api.listProjectProfiles(projectId!),
    enabled: projectId != null,
    staleTime: 30_000,
  });
}

export function useLinkProjectProfile(projectId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (profileId: number) => api.linkProjectProfile(projectId, profileId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["projects", projectId, "profiles"] });
      toast.success("Perfil vinculado");
    },
  });
}

export function useUnlinkProjectProfile(projectId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (profileId: number) => api.unlinkProjectProfile(projectId, profileId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["projects", projectId, "profiles"] });
      toast.success("Perfil desvinculado");
    },
  });
}
